import { useTranslation } from 'react-i18next'
import { DatePicker, Radio } from 'antd'
import {
  disabledScheduleDate,
  disabledScheduleTime,
  parseSchedule,
  scheduleIsoFromPicker,
} from './scheduleTime'

export default function ReleaseScheduleSection({
  immediate,
  scheduled_at,
  editable,
  onChange,
}: {
  immediate: boolean
  scheduled_at: string | null
  editable: boolean
  onChange: (immediate: boolean, scheduled_at: string | null) => void
}) {
  const { t } = useTranslation()

  return (
    <Radio.Group
      value={immediate ? 'now' : 'scheduled'}
      disabled={!editable}
      onChange={(e) => onChange(e.target.value === 'now', scheduled_at)}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <Radio value="now">{t('versionForm.releaseImmediate')}</Radio>
        <Radio value="scheduled">
          <span style={{ marginRight: 10 }}>
            {t('versionForm.releaseScheduled')}
          </span>
          <DatePicker
            showTime={{ format: 'HH:mm' }}
            format="YYYY-MM-DD HH:mm"
            showNow={false}
            disabled={!editable || immediate}
            disabledDate={(d) => disabledScheduleDate(d)}
            disabledTime={(d) => disabledScheduleTime(d)}
            value={parseSchedule(scheduled_at)}
            onChange={(d) => onChange(false, scheduleIsoFromPicker(d))}
            placeholder={t('versionForm.schedulePlaceholder')}
          />
        </Radio>
      </div>
    </Radio.Group>
  )
}
